import { useCallback } from 'react';

import { emit } from '../lib/observe';

export const useDispatch = () => {
	return useCallback((event: string, value?: any) => {
		emit(event, value);
	}, []);
};
